export const NUDGE_IMAGE_WRAPPER = {
    HEIGHT: 65,
    WIDTH: 112,
    BOTTOM: 1,
    RIGHT: 0,
};

export const ANIMATED_BORDER = {
    OFFSET: 1,
};
